module.exports = __webpack_public_path__ + "img/lerqrcode.6520304a.svg";